import React from 'react';

import clsx from 'clsx';

interface SectionFieldNavProps {
  className: string;
  imageSrc?: string;
  name: string;
  onClick?: () => void;
  state?: 'default' | 'selected';
}

export const SectionFieldNav: React.FC<SectionFieldNavProps> = ({
  className,
  imageSrc,
  onClick,
  name,
  state = 'default',
}) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'relative h-14 w-56 cursor-pointer overflow-hidden rounded-md border outline-2 outline-offset-[-1px] transition-all',
        state === 'selected'
          ? 'border-transparent outline-indigo-500'
          : 'border-neutral-100 outline-transparent hover:border-transparent hover:outline-indigo-500',
        className,
      )}
      data-name={name}
    >
      {imageSrc && <img className="h-full max-w-full object-fill" src={imageSrc} alt="icon" />}
    </div>
  );
};
